import React from "react";
import { useRoutes } from "react-router-dom";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { useSelector } from "react-redux";
import RTL from "./layouts/full-layout/customizer/rtl";
import ThemeSettings from "./layouts/full-layout/customizer/ThemeSettings";
import Router from "./routes/router";
import "react-perfect-scrollbar/dist/css/styles.css";



const App = () => {
  const routing = useRoutes(Router);
  const theme = ThemeSettings();
  const customizer = useSelector((state) => state.CustomizerReducer);
  /* The `return` statement in the `App` component is returning a JSX (JavaScript XML) expression. */
  return (
    <ThemeProvider theme={theme}>
      <RTL direction={customizer.activeDir}>
        <CssBaseline />
        {routing}
      </RTL>
    </ThemeProvider>
  );
};

export default App;
